import { declareFont } from '../utils/FontUtils'

import { declaration } from './fonts'


export default {
  '@font-face': Object.values(declaration).map(declareFont),
}
